// Libs
import { combineReducers, createAction } from "@reduxjs/toolkit";
// Slices
import { authSlice, logout } from "./user/slice";
import { settingsSlice } from "./settings/slice";
import { rolesSlice } from "./roles/slice";
import { gamesSlice } from "./gameCenter/games/slice";
import { collectionsSlice } from "./gameCenter/collections/slice";
import { multiScopeSlice } from "./gameCenter/multiScope/slice";
import { categoriesSlice } from "./gameCenter/categories/slice";
import { tagsSlice } from "./gameCenter/tags/slice";
import { providersSlice } from "./gameCenter/providers/slice";
import { gameParsingSlice } from "./gameCenter/parsing/slice";
import { modalsSlice } from "./modals/slice";
import { notificationsSlice } from "./notifications/slice";
import { segmentsSlice } from "./segments/slice";
import { playersSlice } from "./players/list/slice";
import { wagersSlice } from "./liveOps/wagers/slice";
import { bonusesSlice } from "./liveOps/bonuses/slice";
import { outNotifSlice } from "./outAppNotifications/slice";
import { loyaltyLevelsSlice } from "./liveOps/loyalty/levels/slice";
import { loyaltyPointsSlice } from "./liveOps/loyalty/points/slice";
import { depositPointLimitsSlice } from "./liveOps/loyalty/depositPointLimits/slice";
import { cmsBannersSlice } from "./cms/banners/slice";
import { paymentProvidersSlice } from "./payments/providers/slice";
import { paymentMethodsSlice } from "./payments/methods/slice";
import { paymentsDepositSlice } from "./payments/deposits/slice";
import { paymentsWithdrawalsSlice } from "./payments/withdrawals/slice";
import { paymentsOperationsSlice } from "./payments/operations/slice";
import { paymentsCompensationsSlice } from "./payments/compensations/slice";
import { paymentsConfiscationsSlice } from "./payments/confiscations/slice";
import { selectPlayerSlice } from "./payments/selectPlayer/slice";
import { currenciesSlice } from "./payments/currencies/slice";
import { logsSlice } from "./logs/slice";
import { cashbacksSlice } from "./liveOps/casbacks/slice";
import { tournamentsSlice } from "./liveOps/tournaments/slice";
import { promocodesSlice } from "./liveOps/promocodes/slice";
import { cmsPagesSlice } from "./cms/pages/list/slice";
import { cmsSeoSlice } from "./cms/pages/seo/slice";
import { cmsFaqSlice } from "./cms/pages/faq/slice";
import { cashbackGamesSlice } from "./liveOps/cashbackGames/slice";
import { promoSlice } from "./cms/promo/slice";
import { emailSlice } from "./emails/slice";
import { zonesSlice } from "./zones/slice";
import { mirrorSlice } from "./mirror/slice";
import { countrySlice } from "./countries/slice";
import { partnersSlice } from "./cms/footer/partners/slice";
import { socialNetworksSlice } from "./cms/footer/socialNetworks/slice";
import { applicationsSlice } from "./cms/footer/applications/slice";
import { mainTextsSlice } from "./cms/footer/mainTexts/slice";
import { brandCoreSlice } from "./cms/footer/brandCore/slice";
import { paymentsSlice } from "./cms/footer/payments/slice";
import { geoFilterSlice } from "./geoFilter/slice";
import { riskPermissionsSlice } from "./risk/permissions/slice";
import { riskLimitsSlice } from "./risk/limits/slice";
import { riskPlayersSlice } from "./risk/players/slice";
import { riskKycDocumentsSlice } from "./risk/kycDocuments/slice";
import { riskKycPresetSlice } from "./risk/kyc/presets/slice";
import { cmsCustomizedSlice } from "./cms/customized/slice";
import { presetsSlice } from "./players/presets/slice";
import { riskKycRulesSlice } from "./risk/kyc/rules/slice";
import { invalidateList } from './invalidateListAction';
import { schedulerSlice } from "./scheduler/slice";



// Combine root
export const appReducer = combineReducers({
  [authSlice.name]: authSlice.reducer,
  [settingsSlice.name]: settingsSlice.reducer,
  [rolesSlice.name]: rolesSlice.reducer,
  [gamesSlice.name]: gamesSlice.reducer,
  [collectionsSlice.name]: collectionsSlice.reducer,
  [multiScopeSlice.name]: multiScopeSlice.reducer,
  [categoriesSlice.name]: categoriesSlice.reducer,
  [tagsSlice.name]: tagsSlice.reducer,
  [providersSlice.name]: providersSlice.reducer,
  [gameParsingSlice.name]: gameParsingSlice.reducer,
  [modalsSlice.name]: modalsSlice.reducer,
  [notificationsSlice.name]: notificationsSlice.reducer,
  [segmentsSlice.name]: segmentsSlice.reducer,
  [playersSlice.name]: playersSlice.reducer,
  [wagersSlice.name]: wagersSlice.reducer,
  [bonusesSlice.name]: bonusesSlice.reducer,
  [outNotifSlice.name]: outNotifSlice.reducer,
  [loyaltyLevelsSlice.name]: loyaltyLevelsSlice.reducer,
  [loyaltyPointsSlice.name]: loyaltyPointsSlice.reducer,
  [depositPointLimitsSlice.name]: depositPointLimitsSlice.reducer,
  [cmsBannersSlice.name]: cmsBannersSlice.reducer,
  [paymentProvidersSlice.name]: paymentProvidersSlice.reducer,
  [paymentMethodsSlice.name]: paymentMethodsSlice.reducer,
  [paymentsDepositSlice.name]: paymentsDepositSlice.reducer,
  [paymentsWithdrawalsSlice.name]: paymentsWithdrawalsSlice.reducer,
  [paymentsOperationsSlice.name]: paymentsOperationsSlice.reducer,
  [paymentsCompensationsSlice.name]: paymentsCompensationsSlice.reducer,
  [paymentsConfiscationsSlice.name]: paymentsConfiscationsSlice.reducer,
  [selectPlayerSlice.name]: selectPlayerSlice.reducer,
  [currenciesSlice.name]: currenciesSlice.reducer,
  [logsSlice.name]: logsSlice.reducer,
  [cashbacksSlice.name]: cashbacksSlice.reducer,
  [tournamentsSlice.name]: tournamentsSlice.reducer,
  [promocodesSlice.name]: promocodesSlice.reducer,
  [cmsPagesSlice.name]: cmsPagesSlice.reducer,
  [cmsSeoSlice.name]: cmsSeoSlice.reducer,
  [cmsFaqSlice.name]: cmsFaqSlice.reducer,
  [cashbackGamesSlice.name]: cashbackGamesSlice.reducer,
  [promoSlice.name]: promoSlice.reducer,
  [emailSlice.name]: emailSlice.reducer,
  [zonesSlice.name]: zonesSlice.reducer,
  [mirrorSlice.name]: mirrorSlice.reducer,
  [countrySlice.name]: countrySlice.reducer,
  [partnersSlice.name]: partnersSlice.reducer,
  [socialNetworksSlice.name]: socialNetworksSlice.reducer,
  [applicationsSlice.name]: applicationsSlice.reducer,
  [mainTextsSlice.name]: mainTextsSlice.reducer,
  [brandCoreSlice.name]: brandCoreSlice.reducer,
  [paymentsSlice.name]: paymentsSlice.reducer,
  [geoFilterSlice.name]: geoFilterSlice.reducer,
  [riskPermissionsSlice.name]: riskPermissionsSlice.reducer,
  [riskLimitsSlice.name]: riskLimitsSlice.reducer,
  [riskPlayersSlice.name]: riskPlayersSlice.reducer,
  riskKycDocuments: riskKycDocumentsSlice.reducer,
  [cmsCustomizedSlice.name]: cmsCustomizedSlice.reducer,
  [presetsSlice.name]: presetsSlice.reducer,
  [riskKycPresetSlice.name]: riskKycPresetSlice.reducer,
  [riskKycRulesSlice.name]: riskKycRulesSlice.reducer,
  [schedulerSlice.name]: schedulerSlice.reducer,
});



export const rootReducer = (
  state: ReturnType<typeof appReducer> | undefined,
  action: Parameters<typeof appReducer>[1],
) => {
  if (action.type === logout.type) {
    return appReducer(undefined, action);
  }

  const returnedState = appReducer(state, action);

  if (invalidateList.match(action) && state) {
    const { sliceName, field = 'isListFetched' } = action.payload;
    const stateBySlice = state[sliceName];

    return {
      ...returnedState,
      [sliceName]: {
        ...stateBySlice,
        [field]: false,
      }
    }
  }

  return returnedState;
};
